<script>
import { AppDeviceEnquire } from '@/utils/mixin'
import { localize } from '@/utils/i18n'
import '@/styles/app.scss'

export default {
    name: 'App',
    mixins: [AppDeviceEnquire],
    data () {
        return {
            lang: window.App.page.lang,
            app: window.App
        }
    },
    methods: {
        localize: localize
    },
    mounted () {
        // что-то на костыльном, надо подумать
        const container = document.querySelector('#app')
        container.classList.add('is-loaded')
        this.$tippy('[data-tippy-content]')
    }
}
</script>
